<template>
  <div class="wrapper">
    <div class="section">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item  md-xsmall-size-100 mx-auto ">
            <h2 class="title text-center">
              {{ $t("usa.titre") }}
            </h2>
            <h5 class="description">
              {{ $t("usa.description") }}
            </h5>

            <h4 class="title">
              {{ $t("usa.avantage1.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage1.description") }}
            </div>

            <h4 class="title">
              {{ $t("usa.avantage2.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage2.description") }}
            </div>

            <h4 class="title">
              {{ $t("usa.avantage3.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage3.description") }}
            </div>

            <h4 class="title">
              {{ $t("usa.avantage4.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage4.description") }}
            </div>

            <h4 class="title">
              {{ $t("usa.avantage5.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage5.description") }}
            </div>

            <h4 class="title">
              {{ $t("usa.avantage6.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage6.description") }}
            </div>

            <h4 class="title">
              {{ $t("usa.avantage7.titre") }}
            </h4>
            <div>
              {{ $t("usa.avantage7.description") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page"
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
